<template>
  <section class="black-bg">
    <div class="containerWrapper">
      <div class="speakers">
        <h3>Meet the <span class="text-outline">Speakers</span></h3>
        <div class="speakers__list">
          <div v-for="(speaker, i) in speakers" :key="speaker.i">
            <div class="js-tilt">
              <div @click="clickSpeaker(i)" class="speakers__list-pic">
                <div v-for="(item, j) in speaker.photo" :key="j">
                  <img
                    src="../assets/speaker_photo_arrow.svg"
                    alt="Arrow"
                    class="speaker-arrow"
                  />
                  <div class="speaker-photo-crop-wrapper">
                    <img
                      :src="item.url"
                      :alt="speaker.name"
                      class="speaker-photo-crop"
                    />
                  </div>
                  <img :src="item.url" :alt="speaker.name" />
                </div>
                <h4 class="speaker-title">{{ speaker.name }}</h4>
                <p class="speaker-position">
                  <strong>{{ speaker.position }}</strong>
                </p>
                <p class="speaker-workplace">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="#aeaeae"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z"
                      clip-rule="evenodd"
                    /></svg
                  >&nbsp;{{ speaker.company }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { bus } from "../main";
import { fetchDataFromBase } from "../services/fetchDataFromBase";
export default {
  name: "Speakers",
  data() {
    return {
      speakers: null,
    };
  },
  methods: {
    clickSpeaker(i) {
      const selectedSpeaker = this.speakers.filter(function(_s, index) {
        return index === i;
      });

      bus.$emit("openSideboxSpeaker", selectedSpeaker);
      document.body.classList.add("overflow-fix");
    },
  },
  async created() {
    const data = await fetchDataFromBase("speaker");
    this.speakers = data;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.speakers {
  margin-bottom: 3rem;
  padding: 6rem 0rem;
}
.speakers h3 {
  color: var(--text-white);
  text-align: center;
  font-size: 3rem;
  font-weight: 900;
  margin-bottom: 1rem;
}
.speakers .text-outline {
  -webkit-text-stroke: 1.5px var(--text-white);
  color: var(--bg-black);
}
.speakers__list {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 60px;
}
.speakers__list .speakers__list-pic {
  margin: 2rem 0rem;
  cursor: pointer;
  position: relative;
  border: 0px;
  background-color: transparent;
}
.speakers__list .speakers__list-pic .speaker-arrow {
  width: 100%;
  display: none;
  position: absolute;
  transform: scale(1.2);
}
.speakers__list-pic:hover .speaker-arrow {
  display: block;
}
.speaker-photo-crop-wrapper {
  width: 100%;
  height: 50%;
  overflow: hidden;
  position: absolute;
  top: 0;
  z-index: 0;
  border-radius: 2px;
}
.speakers__list h4 {
  font-size: 1.6rem;
  color: var(--primary-color);
  margin-top: 1rem;
}
.speakers__list .speaker-position {
  color: var(--lighter-grey);
  font-size: 1rem;
  margin-bottom: 1.2rem;
}
.speaker-workplace {
  display: flex;
  align-items: flex-start;
  color: var(--lighter-grey);
  font-size: 1rem;
}
@media (max-width: 992px) {
  .speakers__list {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 576px) {
  .speakers__list .speakers__list-pic {
    margin: 0rem 0rem;
  }
  .speakers__list {
    grid-template-columns: 1fr;
  }
  .speakers {
    padding: 0rem 0rem;
  }
  .speakers h3 {
    margin-bottom: 3rem;
  }
}
</style>
